import { useExternalPlatform } from './useExternalPlatform';

/**
 * Google Classroom 또는 LTI 등 외부 플랫폼 내에서 실행 중인지 감지.
 * UI 표시/숨김 분기에만 사용. 플랫폼 고유 기능은 useIsInLti(), useIsInGoogleClassroom() 사용.
 */
export function useIsInExternalPlatform(): boolean {
  return useExternalPlatform().isInExternalPlatform;
}
